//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"ConditionOption",1,1],[0,"ConditionValue",1,1],[0,"Inverse",1,1],[0,"Multiplier",1,1],[0,"OffsetValue",1,1],[0,"PropertyDataType",1,1],[0,"PropertyId",1,1],[0,"SignalDataType",1,1],[0,"SignalName",1,1],[0,"StreamOption",1,1]],[],[]];
SPLM.Mechatronics.ExternalConnectionElementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ExternalConnectionElementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ExternalConnectionElementBuilder.DataType = Object.freeze({
    "Unknown" : "Unknown", "Integer" : "Integer", "Float" : "Float", "Boolean" : "Boolean"});

SPLM.Mechatronics.ExternalConnectionElementBuilder.ConditionType = Object.freeze({
    "Eq" : "Eq", "Gt" : "Gt", "Lt" : "Lt", "Ge" : "Ge", "Le" : "Le", "Ne" : "Ne"});

SPLM.Mechatronics.ExternalConnectionElementBuilder.StreamType = Object.freeze({
    "R" : "R", "W" : "W", "Rw" : "Rw"});

export default SPLM;